
export const statusConfig = {
  'open': {
    backgroundColor: '#D2F5FF',
    color: '#5BC0DE',
    displayName: 'Open'
  },
  'pending': {
    backgroundColor: '#FFDEB7', 
    color: '#D77400',
    displayName: 'Pending'
  },
  'resolved': {
    backgroundColor: '#D6FFD6',
    color: '#5CB85C', 
    displayName: 'Resolved'
  },
  'chatbot': {
    backgroundColor: '#E8F4FD',
    color: '#2196F3',
    displayName: 'Chatbot'
  },
  'expired': {
    backgroundColor: '#FFDBDA',
    color: '#D9534F',
    displayName: 'Expired' 
  },
  'active': {
    backgroundColor: '#E8F5E8',
    color: '#4CAF50',
    displayName: 'Active'
  },
  'agent/unassigned': {
    backgroundColor: '#FFF3E0',
    color: '#FF9800',
    displayName: 'Agent/Unassigned'
  },
  'intervenedchat': {
    backgroundColor: '#F3E5F5',
    color: '#9C27B0',
    displayName: 'IntervenedChat'
  },
  'unresolved': {
    backgroundColor: '#D2F5FF',
    color: '#5BC0DE',
    displayName: 'Open'
  }
};

export const getStatusConfig = (status) => {
  const key = status?.toLowerCase() || 'open';
  return statusConfig[key] || statusConfig['open'];
};